import React from 'react';
import MarketingForm from '../components/MarketingForm';

const Marketing4 = () => {
  // Puput
  return <MarketingForm marketingNumber="Puput" phoneNumber="81519711573" />;
};

export default Marketing4;
